import { render, staticRenderFns } from "./SettingTextInput.vue?vue&type=template&id=4f59439e&"
import script from "./SettingTextInput.vue?vue&type=script&lang=js&"
export * from "./SettingTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports